import { render, staticRenderFns } from "./SettingsCardMailTemplatesSampleOrder.vue?vue&type=template&id=7b1ad6ec&scoped=true"
import script from "./SettingsCardMailTemplatesSampleOrder.vue?vue&type=script&lang=ts"
export * from "./SettingsCardMailTemplatesSampleOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ad6ec",
  null
  
)

export default component.exports